import ContextMenuEntry from '~/components/ContextMenuEntry';
import { useClientListContext } from '../hooks/useClientListContext';
import EditIcon from '~/icons/EditIcon';
import AddItemIcon from '~/icons/AddItemIcon';
import TrashIcon from '~/icons/TrashIcon';

interface IClientContextMenuProps {
  clientReferenceId: string;
}

const ClientContextMenu = ({ clientReferenceId }: IClientContextMenuProps) => {
  const { onOpenEditClientModal, onCreateInvoice, onOpenDeleteClientModal } =
    useClientListContext();

  return (
    <ContextMenuEntry
      sections={[
        {
          key: 'client',
          options: [
            {
              text: 'Edit Client',
              onClick: () => {
                onOpenEditClientModal(clientReferenceId);
              },
              icon: <EditIcon />,
            },
            {
              text: 'New Invoice',
              onClick: () => {
                onCreateInvoice(clientReferenceId);
              },
              icon: <AddItemIcon />,
            },
          ],
        },
        {
          key: 'danger-client',
          options: [
            {
              text: 'Delete',
              color: 'danger',
              onClick: () => {
                onOpenDeleteClientModal(clientReferenceId);
              },
              icon: <TrashIcon />,
            },
          ],
        },
      ]}
    />
  );
};

export default ClientContextMenu;
